exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css"), undefined);

// module
exports.push([module.id, ".selectedCategories__ul__2I-oJ{list-style:none;padding:0}.selectedCategories__accordionTitle__gyuM5{font-family:Open Sans,helvetica,sans-serif;font-size:28px}", ""]);

// exports
exports.locals = {
	"fontFamily": "" + require("-!../../../node_modules/css-loader/index.js?{\"modules\":true,\"localIdentName\":\"[name]__[local]__[hash:base64:5]\"}!../../styles/fonts.css").locals["fontFamily"] + "",
	"ul": "selectedCategories__ul__2I-oJ",
	"accordionTitle": "selectedCategories__accordionTitle__gyuM5"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"modules":true,"localIdentName":"[name]__[local]__[hash:base64:5]"}!./~/postcss-loader?{}!./app/components/selectCategories/selectedCategories.css
// module id = 734
// module chunks = 0